<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" id="profile-tabs">

    <vs-tab v-for="(hour, iHour) in hours" :key="iHour" icon="play_arrow" :label="isSmallerScreen ? weekDays[iHour].short : weekDays[iHour].long">          

      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <vx-card no-shadow>
          <div class="row mb-4">
            <label>Habilitado</label>
             <vs-switch v-model="hour.workingDay" size="large">
               <span slot="on">Sim</span>
              <span slot="off">Não</span>
             </vs-switch>
          </div>

          <div class="flex mb-4">
            <div class="w-2/12">
              <label class="block">Abertura</label>
              <a-time-picker :disabled="!hour.workingDay" placeholder="Escolha um horário" class="w-full" :minuteStep="10" :value="moment(hour.openTime, 'HH:mm')" @change="(a,b) => b ? hour.openTime = b : '00:00'" format="HH:mm" />
            </div>

            <div class="w-2/12 ml-4">
              <label class="block">Fechamento</label>
              <a-time-picker :disabled="!hour.workingDay" placeholder="Escolha um horário" class="w-full" :minuteStep="10" :value="moment(hour.closeTime, 'HH:mm')" @change="(a,b) => b ? hour.closeTime = b : '00:00'" format="HH:mm" />
            </div>
          </div>

        </vx-card>
      </div>
    </vs-tab>

    <div class="flex flex-wrap items-center justify-end mt-2">
      <a-button type="primary" class="mr-4" :loading="loading" size="large" @click="saveSettings">
       {{ loading ? 'Salvando...' : 'Salvar' }}
      </a-button>
    </div>


  </vs-tabs>
</template>

<script>
 import moment from 'moment';
 import firebase from '@/firebase/firebase'

export default {
  
  data () {
    return {
      ref : firebase.firestore(),
      loading : false,
      weekDays : {
        0 : { short: "Dom", long: "Domingo" },
        1 : { short: "Seg", long: "Segunda-feira" },
        2 : { short: "Ter", long: "Terça-feira" },
        3 : { short: "Qua", long: "Quarta-feira" },
        4 : { short: "Qui", long: "Quinta-feira" },
        5 : { short: "Sex", long: "Sexta-feira" },
        6 : { short: "Sab", long: "Sábado" },
      },
      hours : {
        0 : { // domingo
          workingDay : true,
          closeTime : "19:50",
          openTime : "18:00"
        },
        1 : {
          workingDay : true,
          closeTime : "19:50",
          openTime : "18:00"
        },
        2 : {
          workingDay : true,
          closeTime : "19:50",
          openTime : "18:00"
        },
        3 : {
          workingDay : true,
          closeTime : "19:50",
          openTime : "18:00"
        },
        4 : {
          workingDay : true,
          closeTime : "19:50",
          openTime : "18:00"
        },
        5 : {
          workingDay : true,
          closeTime : "19:50",
          openTime : "18:00"
        },
        6 : { // Sábado
          workingDay : true,
          closeTime : "19:50",
          openTime : "18:00"
        }
      }
    }
  },

  created () {
    this.loadSettings()
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },

  methods : {
    moment,

    async loadSettings () {
      try {
        this.loading = true

        let companyId = this.$store.getters.getCompanyID

        let companyInfo = await this.ref.collection('company').doc(companyId).get()
        this.hours = companyInfo.data().hours

      } catch (e) {
        this.$message.error(`[E5009] Erro ao requisitar dados: ${e.message}`, 7)
      } finally {
        this.loading = false
      }
    },

    async saveSettings () {
      try {
        this.loading = true

        let companyId = this.$store.getters.getCompanyID
        let obj = { hours : this.hours }

        let companyInfo = await this.ref.collection('company').doc(companyId).update(obj)

        this.$message.success('Informações da cozinha alteradas com sucesso!', 7)
      } catch (e) {
        this.$message.error(`[E5010] Erro ao salvar: ${e.message}`, 7)
      } finally {
        this.loading = false
      }
    }
  }
}

</script>

<style lang="scss" scoped>
#profile-tabs {
  .vs-tabs--content {
    padding: 10;
  }
}
</style>